const FireItAlert = () => {
    return(
        <div className='popUpModal'>
            <div className='fireItLoading'>
                <button className='infoButton'>
                    🔥
                    <p>Loading!</p>
                </button>
            </div>
        </div>
    )
}

export default FireItAlert;